import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { EMPTY, Observable, from } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationFacade } from '../state';
import * as NotificationPageActions from '../state/notification-page.actions';

export const getErrorMessage = (error: HttpErrorResponse) =>
  window.navigator.onLine
    ? typeof error.error === 'string'
      ? error.error
      : error.message
    : 'There is no Internet connection. Please try again later.';

export const customCatchError = (sideEffectFn?: () => Action[]) => (source: Observable<Action>) =>
  source.pipe(
    catchError((error: HttpErrorResponse) => {
      const extraActions = sideEffectFn ? sideEffectFn() : [];
      return from(
        extraActions.concat(
          NotificationPageActions.failure({
            message: getErrorMessage(error),
          }),
        ),
      );
    }),
  );

export const customCatchErrorNonNgrx =
  (notificationFacade: NotificationFacade, returnDataFn?: () => Observable<any>) =>
  (source: Observable<any>) =>
    source.pipe(
      catchError((error: HttpErrorResponse) => {
        notificationFacade.dispatch(
          NotificationPageActions.failure({
            message: getErrorMessage(error),
          }),
        );
        if (returnDataFn) {
          return returnDataFn();
        } else {
          return EMPTY;
        }
      }),
    );
